import React from "react";

const MobileExploreLinks: React.FC = () => (
  <div className="md:hidden text-white my-10 w-full">
    <h3 className="text-rt-grey-t1 text-sm mb-[18px] text-center font-inter">Explore</h3>
    <div className="text-rt-grey-t3 text-sm">
      <div className="flex flex-wrap justify-center gap-x-10 gap-y-4 mx-5">
        <a href="/use-cases" className="hover:underline">Use cases</a>
        <a href="/about-us" className="hover:underline">About Us</a>
        <a href="/pricing" className="hover:underline">Pricing</a>
        <a href="/customer-reliance" className="hover:underline">Customer Stories</a>
      </div>
    </div>
  </div>
);

export default MobileExploreLinks;
